import styled from 'styled-components';

export const AdvertisingPlatformStyled = styled.div`
  background: var(--color-sonata-secondary-White, #FFF);
  border-radius: var(--spacing-8);
  padding: var(--spacing-24);
  .advertisingPlatform {
    &__title {
      font: var(--font-title-400-regular);
      color: var(--color-sonata-primary-800, #162237);
    }

    &__subtitle {
      font: var(--font-body-400-regular);
      color: var(--color-sonata-primary-600, #3D5787);
      margin-bottom: var(--spacing-16);
    }

    &__body {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
    }

    &__radios {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      
      &Item {
        font-size: ${props => props.theme.fontSizeXS};

        div {
          width: fit-content;
        }
      }
    }
  }
`;

export const PlatformDistributionStyled = styled.div`
  background: var(--color-sonata-primary-200, #F2F5FC);
  border-radius: var(--spacing-8);
  padding: var(--spacing-16);
  .platformDistribution {
    &__title {
      font: var(--font-body-500-medium);
      color: var(--color-sonata-primary-800, #162237);
    }

    &__body {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
      padding: 16px;
    }
  }
`;
